import { FormControl, FormGroup } from '@angular/forms';
import { LoadDiscrepancy } from 'src/app/core/models/reports/reports.model';
import { Options } from '../../../shared/report-format/report-format.constants';

export const CONSTS = {
  HEADER: $localize`Load Discrepancy Report`,
  FROM_LABEL: $localize`From`,
  TO_LABEL: $localize`To`,
  DATE_LABEL: $localize`Date`,
  ROUTE_LABEL: $localize`Route`,
};
export const REPORT_FILE_NAME = 'Load-Discrepancy-Report';

export const PDF_REPORT = {
  NAME: 'Load Discrepancy Report',
  HEADER: {
    GROUP: 'Group:',
    LOOP: 'Loop:',
  },
  COLUMNS: [
    'Loop'.toUpperCase(),
    'Trackno'.toUpperCase(),
    'Time'.toUpperCase(),
    'Driver'.toUpperCase(),
  ],
  DATA_FIELDS: [
    'loop',
    'trackno',
    'time',
    'driver',
  ] as (keyof LoadDiscrepancy)[],
};

type LoadDiscrepenancyReportFormField = {
  fromDate: FormControl<Date>;
  toDate: FormControl<Date>;
  route: FormControl<string>;
  reportFormat: FormControl<Options>;
};

export type LoadDiscrepenancyReportFormGroup =
  FormGroup<LoadDiscrepenancyReportFormField> | null;
